import moment from 'moment';
var parseSyncErrorLog = function (value) {
    if (typeof value !== 'string')
        return value;
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
};
export var formatSyncErrorLog = function (value) {
    var parsed = parseSyncErrorLog(value);
    if (parsed === null || parsed === undefined || parsed === '')
        return '--';
    return typeof parsed === 'object' ? JSON.stringify(parsed) : String(parsed);
};
export var toResubmitRowViewModel = function (item, isReqDocsStage) {
    var _a, _b, _c, _d, _e;
    if (isReqDocsStage === void 0) { isReqDocsStage = false; }
    return ({
        applicationId: String((_a = item === null || item === void 0 ? void 0 : item.ApplicationId) !== null && _a !== void 0 ? _a : '--'),
        contractIdDisplay: String((_b = (isReqDocsStage ? item === null || item === void 0 ? void 0 : item.TxAspireOId : item === null || item === void 0 ? void 0 : item.ApplicationId)) !== null && _b !== void 0 ? _b : '--'),
        customerName: String((_c = item === null || item === void 0 ? void 0 : item.CustomerName) !== null && _c !== void 0 ? _c : '--'),
        portalName: String((_d = item === null || item === void 0 ? void 0 : item.PortalName) !== null && _d !== void 0 ? _d : '--'),
        dealerSalesRepName: String((_e = item === null || item === void 0 ? void 0 : item.SalesRepName) !== null && _e !== void 0 ? _e : '--'),
        applicationDate: (item === null || item === void 0 ? void 0 : item.CreatedTime) ? moment(item.CreatedTime).format('MMMM D, YYYY, h:mm A') : '--',
        errorMessage: formatSyncErrorLog(item === null || item === void 0 ? void 0 : item.SyncErrorLog),
    });
};
